// D.C.T様専用 assets/video-background.js - hidacraft完全準拠版
!function(){"use strict";
  const e="[data-video-template]",
        t="is-loading",
        i="data-video-id";
  
  customElements.get("video-background")||customElements.define("video-background",class extends HTMLElement{
    constructor(){
      super();
    }
    
    connectedCallback(){
      this.videoId=this.getAttribute(i),
      this.videoTemplate=this.querySelector(e),
      this.video=null,
      this.powerSaverVideoPlay=this.powerSaverVideoPlay.bind(this),
      this.videoId&&this.renderVideo();
    }
    
    powerSaverVideoPlay(){
      this.video?.play();
    }
    
    renderVideo(){
      this.videoTemplateObserver=new IntersectionObserver(((e,i)=>{
        e.forEach((e=>{
          if(e.isIntersecting){
            const o=this.videoTemplate.innerHTML;
            this.innerHTML=o,
            this.classList.remove(t),
            this.video=this.querySelector("video"),
            
            // 背景動画は元の挙動のまま（何も変更しない）
            
            this.observeVideoPlayToggle(),
            this.video.play().then((()=>{})).catch((()=>{
              document.addEventListener("click",this.powerSaverVideoPlay,{passive:!0,bubbles:!0,once:!0}),
              document.addEventListener("touchstart",this.powerSaverVideoPlay,{passive:!0,bubbles:!0,once:!0});
            })),
            i.unobserve(e.target);
          }
        }));
      }),{root:null,rootMargin:"300px",threshold:[0,.1,.25,.5,.75,1]}),
      this.videoTemplateObserver.observe(this);
    }
    
    observeVideoPlayToggle(){
      if(!this.video)return;
      this.videoPlayObserver=new IntersectionObserver((e=>{
        e.forEach((e=>{
          const t=e.isIntersecting;
          if(t&&"function"==typeof this.video.play){
            const e=this.video.play();
            void 0!==e&&e.then((e=>{})).catch((e=>{}));
          }
          // 背景動画は元の挙動（画面外で一時停止）
          t||"function"!=typeof this.video.pause||this.video.pause();
        }));
      }),{rootMargin:"0px",threshold:[0,1]}),
      this.videoPlayObserver.observe(this.video);
    }
    
    disconnectedCallback(){
      this.videoTemplateObserver&&this.videoTemplateObserver.disconnect(),
      this.videoPlayObserver&&this.videoPlayObserver.disconnect(),
      this.videoId&&(document.removeEventListener("click",this.powerSaverVideoPlay),document.removeEventListener("touchstart",this.powerSaverVideoPlay));
    }
  });
  
  // モーダル動画のループを確実に停止する処理
  function disableModalVideoLoop() {
    // PhotoSwipeとカスタムポップアップの両方に対応
    const modalVideoSelectors = [
      '.video-popup-content video',
      '.pswp__item video',
      '.custom-video-popup video',
      '[data-video-play] video'
    ];
    
    modalVideoSelectors.forEach(selector => {
      const modalVideos = document.querySelectorAll(selector);
      modalVideos.forEach(video => {
        // 背景動画でないことを確認
        if (!video.closest('video-background') && !video.hasAttribute('data-video-id')) {
          // ループを完全に無効化
          video.loop = false;
          video.removeAttribute('loop');
          
          // SP版でのコントロール非表示
          if (window.innerWidth <= 767) {
            video.controls = false;
            video.removeAttribute('controls');
          }
          
          // 動画終了時の処理を強化
          video.addEventListener('ended', function() {
            this.pause();
            this.currentTime = this.duration; // 最後のフレームで停止
            this.loop = false; // 念のため再度ループを無効化
          }, { passive: true });
          
          // loadedmetadata時にも確実にループを無効化
          video.addEventListener('loadedmetadata', function() {
            this.loop = false;
            this.removeAttribute('loop');
            
            // SP版でのコントロール非表示を確実にする
            if (window.innerWidth <= 767) {
              this.controls = false;
              this.removeAttribute('controls');
            }
          }, { passive: true });
          
          // play時にもループチェック
          video.addEventListener('play', function() {
            if (this.loop) {
              this.loop = false;
              this.removeAttribute('loop');
            }
          }, { passive: true });
          
          // 念のため定期的にループ状態をチェック
          const loopChecker = setInterval(() => {
            if (video.loop) {
              video.loop = false;
              video.removeAttribute('loop');
            }
            
            // 動画が終了している場合はチェックを停止
            if (video.ended || video.paused) {
              clearInterval(loopChecker);
            }
          }, 1000);
        }
      });
    });
  }
  
  // DOMContentLoaded時の処理
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(disableModalVideoLoop, 100);
    
    // MutationObserverでDOM変更を監視
    const observer = new MutationObserver(function(mutations) {
      let shouldCheck = false;
      mutations.forEach(mutation => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { // Element node
              if (node.querySelector && (
                node.querySelector('video') || 
                node.classList.contains('pswp') ||
                node.classList.contains('video-popup-content')
              )) {
                shouldCheck = true;
              }
            }
          });
        }
      });
      
      if (shouldCheck) {
        setTimeout(disableModalVideoLoop, 50);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
  
  // Shopifyセクションロード時の処理
  document.addEventListener('shopify:section:load', function() {
    setTimeout(disableModalVideoLoop, 100);
  });
  
  // PhotoSwipe初期化時の処理
  document.addEventListener('pswpInit', function() {
    setTimeout(disableModalVideoLoop, 50);
  });
  
  // リサイズ時の処理（デバイス切り替え対応）
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const modalVideos = document.querySelectorAll('.video-popup-content video, .pswp__item video');
      modalVideos.forEach(video => {
        if (!video.closest('video-background') && !video.hasAttribute('data-video-id')) {
          if (window.innerWidth <= 767) {
            // SP版：コントロール非表示
            video.controls = false;
            video.removeAttribute('controls');
          } else {
            // PC版：コントロール表示
            video.controls = true;
            video.setAttribute('controls', 'controls');
          }
        }
      });
    }, 250);
  });
  
}();